import clsx from 'clsx'
import BaseMenu, { MenuProps as BaseMenuProps } from 'antd/lib/menu'

export interface MenuProps extends BaseMenuProps {}

export const Menu = (props: MenuProps): JSX.Element => (
  <>
    <BaseMenu className={clsx('bg-gray-50')} {...props} />
  </>
)
